export const meAccessQuery = `
    query meAccess {
        me {
            hasAccessToSpecialPosts
            user {
                workspaces {
                    id
                    roleId
                    userId
  
                workspace {
                    slug
                }

                workspaceId
                }
            }
        }
    }
`;
